import React, { useContext } from 'react';
import { Form, Select } from 'antd';

import { useFormatMessage } from '../hooks';
import { DataContext } from "../context"

const { Item } = Form;

const Sender = ({ orderType, editing = false }) => {
  const { senders } = useContext(DataContext)

  const f = useFormatMessage()
  const options = senders.map(s => ({ value: s.id, label: s.name }))

  return (
    <Item
      name="senderId"
      hidden={senders.length === 1}
      label={orderType === 'collection'
        ? f('CreateCollection.ReceivingCompany')
        : f('DeliveryColumn.sender.name')}
      hasFeedback
      rules={[{
        required: true, message: f("CreateDelivery.SenderRequired")
      }]}
    >
      {editing
        ?
        <Select
          optionFilterProp="label"
          optionLabelProp="label"
          showSearch
          options={options}
        />
        :
        <Select
          optionLabelProp="label"
          open={false}
          suffixIcon={null}
          options={options}
        />
      }
    </Item>
  )
}

export default Sender
